module.exports = __webpack_public_path__ + "img/video-player.e6a7623e.png";